<template>
  <div>
    <div class="form-group" style="border-top: 1px dashed #e5e5e5;">
      <b-row>
        <b-col xl="3" lg="4" md="5" sm="12" cols="12" class="no-padding">
          <label class="control-label">Ajouter une réglementation ?</label>
        </b-col>
        <b-col xl="9" lg="8" md="7" sm="12" cols="12" class="form-with-label">
          <b-form-radio-group
            v-model="isReglementation"
            :options="options"
          ></b-form-radio-group>
        </b-col>
      </b-row>
    </div>

    <div v-if="isReglementation == true">
      <div class="header">
        <h3>Réglementation souhaitée</h3>
      </div>
      <div class="block-content">
        <div class="form-group">
          <b-row>
            <b-col xl="3" lg="6" md="6" sm="12" cols="12" class="no-padding">
              <label class="control-label"
                >Durée de la réglementation <span>(en jours calendaires)</span>
                <span class="red">*</span> :</label
              >
            </b-col>
            <b-col xl="2" lg="6" md="6" sm="12" cols="12">
              <ValidationProvider
                mode="lazy"
                v-slot="{ errors }"
                rules="required"
                name="durée de la réglementation "
              >
                <b-form-input
                  :state="errors[0] ? false : null"
                  v-model="cerfa.durationRegulation"
                  type="number"
                />
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
            </b-col>
            <b-col xl="3" lg="6" md="6" sm="12" cols="12" class="no-padding">
              <label class="control-label"
                >Date de début de réglementation
                <span class="red">*</span> :</label
              >
            </b-col>
            <b-col xl="4" lg="6" md="6" sm="12" cols="12">
              <ValidationProvider
                mode="lazy"
                v-slot="{ errors }"
                rules="required"
                name="date de début de réglementation"
              >
                <b-form-datepicker
                  :state="errors[0] ? false : null"
                  hide-header
                  placeholder="Date"
                  today-button
                  :start-weekday="1"
                  today-button-variant="primary"
                  label-help=""
                  label-today-button="Aujourd'hui"
                  v-model="cerfa.dateRegulation"
                ></b-form-datepicker>
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
            </b-col>
          </b-row>
        </div>

        <div class="form-group">
          <b-row>
            <b-col xl="2" lg="3" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label"
                >Type de restriction <span class="red">*</span> :</label
              >
            </b-col>
            <b-col
              xl="10"
              lg="9"
              md="9"
              sm="12"
              cols="12"
              class="form-with-label"
            >
              <ValidationProvider
                mode="lazy"
                v-slot="{ errors }"
                rules="required"
                name="type de restriction"
              >
                <b-form-radio-group
                  :state="errors[0] ? false : null"
                  v-model="cerfa.restrictionSuspenders"
                  :options="restrictions"
                ></b-form-radio-group>
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
            </b-col>
          </b-row>
        </div>
        <div class="form-group">
          <b-row>
            <b-col xl="2" lg="3" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label"
                >Sens de circulation concerné
                <span class="red">*</span> :</label
              >
            </b-col>
            <b-col
              xl="10"
              lg="9"
              md="9"
              sm="12"
              cols="12"
              class="form-with-label"
            >
              <ValidationProvider
                mode="lazy"
                v-slot="{ errors }"
                rules="required"
                name="sens de circulation"
              >
                <b-form-radio-group
                  :state="errors[0] ? false : null"
                  v-model="cerfa.directionTraffic"
                  :options="traffics"
                ></b-form-radio-group>
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
            </b-col>
          </b-row>
        </div>
        <div class="form-group">
          <b-row>
            <b-col xl="2" lg="3" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label"
                >Circulation alternée <span class="red">*</span> :</label
              >
            </b-col>
            <b-col
              xl="10"
              lg="9"
              md="9"
              sm="12"
              cols="12"
              class="form-with-label"
            >
              <ValidationProvider
                mode="lazy"
                v-slot="{ errors }"
                rules="required"
                name="sens de circulation"
              >
                <b-form-radio-group
                  :state="errors[0] ? false : null"
                  v-model="cerfa.alternatingCirculationManual"
                  :options="alternates"
                ></b-form-radio-group>
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
            </b-col>
          </b-row>
        </div>
        <div class="form-group">
          <b-row>
            <b-col xl="2" lg="3" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label">Restriction de chaussée :</label>
            </b-col>
            <b-col xl="10" lg="9" md="9" sm="12" cols="12">
              <!-- TODO changer les values attendues -->
              <b-form-checkbox v-model="cerfa.emergencyRestriction">
                Neutralisation de la bande d'arrêt d'urgence (BAU)
              </b-form-checkbox>
              <b-form-checkbox v-model="cerfa.encroachmentRoadway">
                Empiètement sur chaussée
              </b-form-checkbox>
              <b-form-checkbox v-model="numberWayRemovedBool">
                Suppression de voie
              </b-form-checkbox>
            </b-col>
            <b-col
              lg="12"
              md="12"
              sm="12"
              cols="12"
              class="marginTop"
              v-if="cerfa.encroachmentRoadway"
            >
              <b-row>
                <b-col
                  xl="4"
                  lg="5"
                  md="5"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label"
                    >Largeur de voie maintenue :</label
                  >
                </b-col>
                <b-col xl="8" lg="7" md="7" sm="12" cols="12">
                  <b-form-input
                    v-model="cerfa.trackWidthMaintained"
                    type="number"
                    placeholder="Largeur de voie maintenue"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col
              lg="12"
              md="12"
              sm="12"
              cols="12"
              class="marginTop"
              v-if="numberWayRemovedBool"
            >
              <b-row>
                <b-col
                  xl="4"
                  lg="5"
                  md="5"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label"
                    >Nombre de voie(s) supprimée(s) :</label
                  >
                </b-col>
                <b-col xl="8" lg="7" md="7" sm="12" cols="12">
                  <b-form-input
                    v-model="cerfa.numberWayRemoved"
                    type="number"
                    placeholder="Nombre de voie(s) supprimée(s)"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <div class="form-group">
          <b-row>
            <b-col lg="4" md="4" sm="12" cols="12">
              <b-row class="no-margin">
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="no-padding text-center"
                >
                  <div class="control-label text-center"><b>Circuler</b></div>
                </b-col>
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="no-padding text-center"
                >
                  <b-form-checkbox v-model="cerfa.moveCar">
                    Véhicules légers
                  </b-form-checkbox>
                  <b-form-checkbox v-model="cerfa.moveTruck">
                    Poids lourds
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="4" md="4" sm="12" cols="12">
              <b-row class="no-margin">
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="no-padding text-center"
                >
                  <div class="control-label text-center"><b>Stationner</b></div>
                </b-col>
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="no-padding text-center"
                >
                  <b-form-checkbox v-model="cerfa.parkCar">
                    Véhicules légers
                  </b-form-checkbox>
                  <b-form-checkbox v-model="cerfa.parkTruck">
                    Poids lourds
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="4" md="4" sm="12" cols="12">
              <b-row class="no-margin">
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="no-padding text-center"
                >
                  <div class="control-label text-center"><b>Dépasser</b></div>
                </b-col>
                <b-col
                  lg="12"
                  md="12"
                  sm="12"
                  cols="12"
                  class="no-padding text-center"
                >
                  <b-form-checkbox v-model="cerfa.overtakeCar">
                    Véhicules légers
                  </b-form-checkbox>
                  <b-form-checkbox v-model="cerfa.overtakeTruck">
                    Poids lourds
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <div class="form-group">
          <b-row>
            <b-col xl="2" lg="3" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label">Vitesse limitée à :</label>
            </b-col>
            <b-col xl="4" lg="5" md="6" sm="12" cols="12">
              <b-form-input type="number" v-model="cerfa.limitedSpeed" />
            </b-col>
            <b-col xl="6" lg="4" md="3" sm="12" cols="12">
              <div class="control-label font-normal text-left">km/h</div>
            </b-col>
          </b-row>
        </div>

        <div class="form-group">
          <b-row>
            <b-col xl="2" lg="3" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label"
                >Itinéraire de déviation <span>(à préciser par sens)</span>
                <span class="red">*</span> :</label
              >
            </b-col>
            <b-col xl="10" lg="9" md="9" sm="12" cols="12">
              <ValidationProvider
                mode="lazy"
                v-slot="{ errors }"
                rules="required"
                name="itinéraire de déviation"
              >
                <b-form-textarea
                  :state="errors[0] ? false : null"
                  v-model="cerfa.detourRoute"
                  style="height:150px;"
                  placeholder="Itinéraire de déviation"
                ></b-form-textarea>
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
            </b-col>
          </b-row>
        </div>

        <div class="form-group">
          <b-row>
            <b-col xl="2" lg="3" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label"
                >Autres prescriptions <span class="red">*</span> :</label
              >
            </b-col>
            <b-col xl="10" lg="9" md="9" sm="12" cols="12">
              <ValidationProvider
                mode="lazy"
                v-slot="{ errors }"
                rules="required"
                name="autres prescriptions"
              >
                <b-form-textarea
                  :state="errors[0] ? false : null"
                  v-model="cerfa.otherPrescriptions"
                  style="height:150px;"
                  placeholder="Autres prescriptions"
                ></b-form-textarea>
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";
export default {
  name: "Reglementation",
  props: ["value"],
  methods: {
    ...Vuex.mapActions("Cerfa", ["setCerfa14024"]),
  },
  computed: {
    ...Vuex.mapGetters("Cerfa", ["cerfa14024"]),
    cerfa: {
      get: function() {
        return this.cerfa14024;
      },
      set: function(newValue) {
        this.setCerfa14024(newValue);
      },
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.isReglementation = true;
    }
  },
  data() {
    return {
      numberWayRemovedBool: false,
      restrictions: [
        { text: "Restriction sur section courante", value: false },
        { text: "Restriction sur bretelles", value: true },
      ],
      traffics: [
        { text: "Deux sens de circulation", value: "Deux sens de circulation" },
        {
          text: "Sens des points de Repères (PR) croissants",
          value: "Sens des points de Repères (PR) croissants",
        },
        {
          text: "Sens des points de Repères (PR) décroissants",
          value: "Sens des points de Repères (PR) décroissants",
        },
        {
          text: "Fermeture à la circulation",
          value: "Fermeture à la circulation",
        },
        {
          text: "Basculement de circulation sur chaussée opposée",
          value: "Basculement de circulation sur chaussée opposée",
        },
      ],
      alternates: [
        { text: "Par feux tricolores", value: false },
        { text: "Manuelle", value: true },
      ],
      options: [
        { text: "Oui", value: true },
        { text: "Non", value: false },
      ],
      isReglementation: false,
    };
  },
};
</script>

<style scoped></style>
